// Decimals and Commas, $ Optional
const currencyRegex = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;
const wholeIntergerRegex = /^-?\d+$/;
const decimalNumberRegex = /^-?\d+\.?(\d{1,2})?$/;
const calcDecimalNumberRegex = /^-?\d+\.?(\d{1,6})?$/;
export const validateUSDCurrencyValue = val => {
  return currencyRegex.test(val);
};
export const validateWholeInteger = interger => {
  if (interger) {
    return wholeIntergerRegex.test(interger);
  }
  return true;
};
export const validateCalcDecimalNumber = number => {
  return calcDecimalNumberRegex.test(number);
};

// Decimal Optional
export const validateDecimalNumber = number => {
  return decimalNumberRegex.test(number);
};